import { useNavigate } from "react-router-dom";
import React, {useRef, useState, useEffect } from "react";
import logo from "../assets/logo.png";
import down from "../assets/Down.svg";
import header from "../assets/Header.png";
import flag from "../assets/Flag.png";
import bulb from "../assets/Bulb.png";
import mini from "../assets/Mini.png";
import rocket from "../assets/Rocket.png";
import twit from "../assets/Twit.png";
import magic from "../assets/Magic.png";
import light from "../assets/Light.png";
import { toast, ToastContainer } from "react-toastify";
import human from "../assets/Human.png";
import ok from "../assets/Ok.png";
import women from "../assets/Women.png";
import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import icon from "../assets/Icon.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import riarr from "../assets/Rightarr.svg";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import trial from "../assets/Trial.png";
import { Link } from "react-router-dom";
import phone from "../assets/Phone.png";
import ee from "../assets/Email.png";
import bo1 from "../assets/Bo1.png";
import bo2 from "../assets/Bo2.png";
import bo3 from "../assets/Bo3.png";
import bo4 from "../assets/Bo4.png";
import bo5 from "../assets/Bo5.png";
import bo6 from "../assets/Bo6.png";
import bo7 from "../assets/Bo7.png";
import bo8 from "../assets/Bo8.png";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import right from "../assets/Right.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Do.png";
import trans from "../assets/Trans.png";

const About = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Home");
  const [showDropdown, setShowDropdown] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
const [hoveredItem, setHoveredItem] = useState(null);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };

 const dropdownItems = [
    {
      title: "LOGISTICS OPERATIONS",
      items: [
      {
    name: "Gate",
    description: (
      <>
        Helps organizations track and manage
        <br />
        visitors efficiently.
      </>
    ),
    icon: gate,
  },
        // {
        //   icon: dock,
        //   name: "Dock",
        //   description:
        //     "Helps businesses streamline loading, unloading & scheduling.",
        // },
        // {
        //   icon: sign,
        //   name: "Signage",
        //   description:
        //     "Creating, managing & displaying digital content on screens.",
        // },
      ],
    },
    // {
    //   title: "TRACKING SYSTEM",
    //   items: [
    //     {
    //       icon: trans,
    //       name: "Transport",
    //       description:
    //         "Helps users efficiently manage & optimize transportation services.",
    //     },
    //     {
    //       icon: bus,
    //       name: "Vehicle Management",
    //       description:
    //         "Tracks vehicles, optimizes routes, and automates expenses.",
    //     },
    //     {
    //       icon: asset,
    //       name: "Asset",
    //       description:
    //         "Helps businesses track, monitor, and manage assets efficiently.",
    //     },
    //   ],
    // },
    {
      title: "WORKFORCE MANAGEMENT",
      items: [
       {
    name: "MeetQ",
    description: (
      <>
        Book & manage meeting rooms
        <br />
        with real-time tracking.
      </>
    ),
    icon: q,
  },
        // {
        //   icon: tg,
        //   name: "TickGo",
        //   description: "Track tasks, log hours, and update statuses.",
        // },
        // {
        //   icon: n,
        //   name: "Nexus",
        //   description: "Manage attendance, tasks, and productivity.",
        // },
      ],
    },
  ];

  const handleClick = (item) => {
    setActiveItem(item);
    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }
    if (item === "Pricing") {
      navigate("/new");
    }
    if (item === "Home") {
      navigate("/");
    }
    if (item === "Say Hello") {
      navigate("/contact");
    }
    if (item === "Partner") {
      navigate("/part");
    }
  };

  const expertiseData = [
    { image: bo1, title: "Meeting Market Demand", bgColor: "#FFF8E7" },
    { image: bo2, title: "Diversification and Expansion", bgColor: "#E2FFE5" },
    { image: bo3, title: "Streamlining Operations", bgColor: "#EBF4FF" },
    { image: bo4, title: "Control Over Supply Chain", bgColor: "#FFE4E4" },
    { image: bo5, title: "Vertical Integration", bgColor: "#F6E9FF" },
    { image: bo6, title: "Cost Savings", bgColor: "#FFFEDB" },
    { image: bo7, title: "Customization and Flexibility", bgColor: "#EDF5FF" },
    { image: bo8, title: "Competitive Advantage", bgColor: "#FFE8EC" },
  ];

  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];

  const [position, setPosition] = useState({
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
  });

  useEffect(() => {
    const randomizePosition = () => {
      setPosition({
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
      });
    };
    const interval = setInterval(randomizePosition, 2000);
    return () => clearInterval(interval);
  }, []);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const randomTexts = [
    {
      heading: "Meeting Market Demand",
      text: "There may be a growing demand for manufacturing, warehousing, and logistics services in a particular region or industry.",
    },
    {
      heading: "Diversification and Expansion",
      text: "For existing businesses, establishing a manufacturing warehouse and logistics arm can be a way to diversify revenue.",
    },
    {
      heading: "Seamless Integration Ahead",
      text: "Companies may establish manufacturing, warehousing, and logistics operations to streamline supply chains and cut costs.",
    },
    {
      heading: "Control Over Supply Chain",
      text: "Owning and operating manufacturing, warehousing, and logistics facilities enhances supply chain control, enabling faster responses.",
    },
    {
      heading: "Vertical Integration",
      text: "Some companies choose to vertically integrate by incorporating manufacturing, warehousing, and logistics functions into their operations.",
    },
    {
      heading: "Cost Savings",
      text: "By uniting manufacturing, warehousing, and logistics, companies can reduce costs through economies of scale.",
    },
    {
      heading: "Customization and Flexibility",
      text: "A dedicated manufacturing warehouse and logistics company can offer customized solutions tailored to the specific needs of clients.",
    },
    {
      heading: "Competitive Advantage",
      text: "Having a well-developed manufacturing warehouse and logistics infrastructure can provide a competitive advantage in the marketplace.",
    },
  ];

   const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
     const isMobile = screenWidth <= 768;
  const isTablet = screenWidth > 768 && screenWidth <= 1024;






 

// function generateCaptcha() {
//   return Math.random().toString(36).substring(2, 7).toUpperCase();
// }

// // 2️⃣  Helper to paint the captcha
// function drawCaptcha(text) {
//   const canvas = canvasRef.current;
//   if (!canvas) return;                          // guard against null
//   const ctx = canvas.getContext("2d");

//   ctx.clearRect(0, 0, canvas.width, canvas.height);
//   ctx.fillStyle = "#ffffff";
//   ctx.fillRect(0, 0, canvas.width, canvas.height);

//   // letters
//   for (let i = 0; i < text.length; i++) {
//     const x = 20 + i * 20;
//     const y = 30 + Math.random() * 8;
//     const angle = (Math.random() - 0.5) * 0.5;

//     ctx.save();
//     ctx.translate(x, y);
//     ctx.rotate(angle);
//     ctx.font = "bold 22px Arial";
//     ctx.fillStyle = "#0A3A72";
//     ctx.fillText(text[i], 0, 0);
//     ctx.restore();
//   }

//   // noise-lines
//   for (let i = 0; i < 4; i++) {
//     ctx.beginPath();
//     ctx.moveTo(Math.random() * 120, Math.random() * 40);
//     ctx.lineTo(Math.random() * 120, Math.random() * 40);
//     ctx.strokeStyle = "#9ca3af";
//     ctx.stroke();
//   }

//   // noise-dots
//   for (let i = 0; i < 40; i++) {
//     ctx.beginPath();
//     ctx.arc(Math.random() * 120, Math.random() * 40, 1, 0, 2 * Math.PI);
//     ctx.fillStyle = "#64748b";
//     ctx.fill();
//   }
// }

// // 3️⃣  Draw once – after the first DOM paint
// useEffect(() => {
//   if (canvasRef.current) drawCaptcha(captcha);
// }, []);                                          // ← mount only

// // 4️⃣  Reload button








const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
   const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
  
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
  
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
  
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
  
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
  
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
  
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };

    const handleSubscribe = async () => {
        try {
          const response = await fetch(
            "https://api-uat.mawalog.com/admin/v2/api/newsletter",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": token,
              },
              body: JSON.stringify({
                session_id: sessionid,
                captcha: userCaptcha,
                email: email,
                type: "Mawalog",
              }),
            }
          );
    
          const result = await response.json();
          console.log("Response:", userCaptcha, " ", data);
          setEmail("");
         setUserCaptcha("");
          toast(result.message);
        } catch (error) {
          console.error("Error sending request:", error);
        }
      };
    


  return (
    <div>
              <ToastContainer
         position="bottom-right"
         autoClose={3000}
         style={{ bottom: "80px" }}
       />
      {/* Floating Button */}
      {/* <div
        style={{
          position: "fixed",
          bottom: "clamp(1.5rem, 5vw, 2.5rem)",
          right: "clamp(1rem, 3vw, 1.5rem)",
          zIndex: 20,
        }}
      >
        <button
          style={{
            padding: 0,
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <img
            src={icon}
            alt="button icon"
            style={{
              width: "clamp(30px, 4vw, 50px)",
              height: "clamp(30px, 4vw, 50px)",
            }}
          />
        </button>
      </div> */}

    <>
            <div
      style={{
        fontFamily: "Epilogue",
        lineHeight: "1.4",
        top: 0,
        zIndex: 1000,
        display: "flex",
        position: "sticky",
        justifyContent: "space-between",
        alignItems: "center",
        padding: isMobile ? "10px 3%" : "0px 5%",
        backgroundColor: "#fff",
        flexWrap: "wrap",
         borderBottom: "1px solid #ddd",
      }}
    >
    
    <div
      onClick={() => {
        if (window.location.pathname === "/") {
          window.location.reload();
        } else {
          window.location.href = "/";
        }
      }}
      style={{ cursor: "pointer" }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{
          maxWidth: isMobile ? "120px" : "150px",
          height: "auto",
          marginLeft: isMobile ? "-10px" : "-50px",
        }}
      />
    </div>
    
       
               {/* Mobile Hamburger Icon */}
               {isMobile && (
                 <button
                   onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                   style={{ background: "none", border: "none", cursor: "pointer" }}
                 >
                   <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                   </svg>
                 </button>
               )}
       
               {/* Desktop/Tablet Menu */}
               {!isMobile && (
                 <div
                   style={{
                     display: "flex",
                     alignItems: "center",
                     gap: "8px",
                     flexDirection: "row",
                     width: "auto",
                     backgroundColor: "transparent",
                     padding: "0",
                   }}
                 >
    {["Products", "Partner", "Say Hello"].map((item, index) => (
            <div
              key={index}
              style={{ position: "relative", width: "auto" }}
              onMouseEnter={() => {
                setHoveredItem(item);
                if (item === "Products") setShowDropdown(true);
              }}
              onMouseLeave={() => {
                setHoveredItem(null);
                if (item === "Products") setShowDropdown(false);
              }}
            >
              <div
                onClick={() => handleClick(item)}
                style={{
                  fontSize: "clamp(12px, 2vw, 16px)",
                  cursor: "pointer",
                  fontWeight: "normal",
                  backgroundColor:
                    activeItem === item || hoveredItem === item
                      ? "#EAF3FF"
                      : "transparent",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  transition: "background-color 0.3s",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  justifyContent: "flex-start",
                }}
              >
                {item}
                {item === "Products" && (
                  <img
                    src={down}
                    alt="Down Arrow"
                    style={{
                      width: "10px",
                      height: "7px",
                      transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s",
                    }}
                  />
                )}
              </div>
    
              {item === "Products" && showDropdown && (
                <div
                  onMouseEnter={() => setShowDropdown(true)}
                  onMouseLeave={() => setShowDropdown(false)}
                  style={{
                    position: "fixed",
                    top: 30,
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 9999,
                    marginTop: "20px",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    borderRadius: "24px",
                    overflow: "hidden",
                    width: "min(980px, 90vw)",
                    maxWidth: "100%",
                    padding: "16px",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                    gap: "16px",
                    boxSizing: "border-box",
                  }}
                >
                  {dropdownItems.map((section, i) => (
                    <div
                      key={i}
                      style={{
                        paddingRight:
                          i < dropdownItems.length - 1 ? "16px" : undefined,
                        borderRight:
                          i < dropdownItems.length - 1
                            ? "1px solid #E0E0E0"
                            : "none",
                      }}
                    >
                      <div
                        style={{
                          color: "#666",
                          fontWeight: 600,
                          marginBottom: 12,
                          textTransform: "uppercase",
                          fontSize: 12,
                        }}
                      >
                        {section.title}
                      </div>
    
                      {section.items.map((product, j) => (
                        <div
                          key={j}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 10,
                            padding: "8px",
                            cursor: "pointer",
                            marginBottom: 8,
                            borderRadius: 8,
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => {
                            if (product.name === "Gate") navigate("/gate");
                            else if (product.name === "MeetQ") navigate("/meetq");
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#F0F8FF";
                            const name = e.currentTarget.querySelector(
                              ".product-name"
                            );
                            const arrow = e.currentTarget.querySelector(".arrow-icon");
                            if (name) name.style.color = "#004aad";
                            if (arrow) {
                              arrow.style.filter =
                                "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                              arrow.style.transform = "translateX(4px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                            const name = e.currentTarget.querySelector(
                              ".product-name"
                            );
                            const arrow = e.currentTarget.querySelector(".arrow-icon");
                            if (name) name.style.color = "inherit";
                            if (arrow) {
                              arrow.style.filter = "none";
                              arrow.style.transform = "translateX(0)";
                            }
                          }}
                        >
                          <img
                            src={product.icon}
                            alt={product.name}
                            style={{ width: 20, height: 20 }}
                          />
                          <div>
                            <div
                              className="product-name"
                              style={{
                                fontWeight: 600,
                                display: "flex",
                                alignItems: "center",
                                transition: "color 0.3s ease",
                                fontSize: 13,
                              }}
                            >
                              {product.name}
                              <img
                                className="arrow-icon"
                                src={nr}
                                alt="arrow"
                                style={{
                                  marginLeft: 4,
                                  width: 16,
                                  height: 16,
                                  transition: "filter 0.3s ease, transform 0.3s ease",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                color: "#666",
                                fontSize: 12,
                                textAlign: "left",
                                lineHeight: 1.4,
                              }}
                            >
                              {product.description}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
    
       
                   <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                     <button
      onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
      className="login-button"
      style={{
        padding: "10px 20px",
        borderRadius: "20px",
        border: "1px solid #004aad",
        backgroundColor: "#fff",
        color: "#004aad",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "16px",
        transition: "background-color 0.3s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
    >
      Login
    </button>
    
                     <button
                       onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                       className="register-button"
                       style={{
                         padding: "10px 20px",
                         borderRadius: "20px",
                         border: "none",
                         backgroundColor: "#004aad",
                         color: "#fff",
                         fontWeight: "bold",
                         cursor: "pointer",
                         fontSize: "16px",
                         transition: "background-color 0.3s",
                       }}
                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                     >
                       Register
                     </button>
                   </div>
                 </div>
               )}
             </div>
       
             {/* Mobile Menu */}
             {isMobile && isMobileMenuOpen && (
               <div
                 style={{
                   position: "fixed",
                   top: 0,
                   left: 0,
                   width: "100%",
                   height: "100%",
                   backgroundColor: "#fff",
                   padding: "20px",
                   overflowY: "auto",
                   zIndex: 1001,
                   boxSizing: "border-box",
                   fontFamily: "Epilogue, sans-serif",
                 }}
               >
                 {/* Header with Logo and Close Button */}
                 <div
                   style={{
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center",
                     marginBottom: "20px",
                   }}
                 >
                   <Link to="/">
      <img
        src={logo}
        alt="Logo"
        style={{ width: "120px", height: "auto", cursor: "pointer" }}
      />
    </Link>
                   <button
                     onClick={() => setIsMobileMenuOpen(false)}
                     style={{ background: "none", border: "none", cursor: "pointer" }}
                   >
                     <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                       <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                     </svg>
                   </button>
                 </div>
       
                 {/* Navigation Items */}
                 {["Products", "Partner", "Say Hello"].map((item, index) => (
                   <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                     {item === "Products" ? (
                       <>
                         <div
                           onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                           style={{
                             fontSize: "16px",
                             cursor: "pointer",
                             fontWeight: "600",
                             color: "#004aad",
                             padding: "12px",
                             display: "flex",
                             justifyContent: "center",
                             alignItems: "center",
                             borderRadius: "8px",
                             transition: "background-color 0.3s",
                             textAlign: "center",
                           }}
                           onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                           onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                         >
                           Products
                           <img
                             src={down}
                             alt="Arrow"
                             style={{
                               width: "10px",
                               height: "7px",
                               transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                               transition: "transform 0.3s",
                             }}
                           />
                         </div>
                         {mobileProductsOpen && (
                           <div
                             style={{
                               marginTop: "12px",
                               padding: "16px",
                               backgroundColor: "#F9FAFB",
                               borderRadius: "12px",
                               display: "flex",
                               flexDirection: "column",
                               gap: "16px",
                               maxWidth: "100%",
                               overflow: "auto",
                               boxSizing: "border-box",
                               justifyContent: "center",
                               alignItems: "center",
                               textAlign: "center",
                             }}
                           >
                             {dropdownItems.map((section, i) => (
                               <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                                 <div
                                   style={{
                                     color: "#666",
                                     fontWeight: "600",
                                     textTransform: "uppercase",
                                     fontSize: "12px",
                                     marginBottom: "8px",
                                   }}
                                 >
                                   {section.title}
                                 </div>
                                 {section.items.map((product, j) => (
                                   <div
                                     key={j}
                                     style={{
                                       display: "flex",
                                       flexDirection: "column",
                                       alignItems: "center",
                                       gap: "8px",
                                       padding: "8px",
                                       cursor: "pointer",
                                       borderRadius: "8px",
                                       transition: "background-color 0.3s ease",
                                       maxWidth: "100%",
                                     }}
                                     onClick={() => {
                                       if (product.name === "Gate") navigate("/gate");
                                       else if (product.name === "MeetQ") navigate("/meetq");
                                       setIsMobileMenuOpen(false);
                                     }}
                                     onMouseEnter={(e) => {
                                       e.currentTarget.style.backgroundColor = "#F0F8FF";
                                       const name = e.currentTarget.querySelector(".product-name");
                                       name.style.color = "#004aad";
                                     }}
                                     onMouseLeave={(e) => {
                                       e.currentTarget.style.backgroundColor = "transparent";
                                       const name = e.currentTarget.querySelector(".product-name");
                                       name.style.color = "inherit";
                                     }}
                                   >
                                     <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                     <div style={{ flex: 1, overflow: "hidden" }}>
                                       <div
                                         className="product-name"
                                         style={{
                                           fontWeight: "600",
                                           fontSize: "14px",
                                           transition: "color 0.3s ease",
                                           whiteSpace: "normal",
                                           overflow: "hidden",
                                           textOverflow: "ellipsis",
                                           textAlign: "center",
                                         }}
                                       >
                                         {product.name}
                                       </div>
                                       <div
                                         style={{
                                           color: "#666",
                                           fontSize: "12px",
                                           lineHeight: "1.4",
                                           overflowWrap: "break-word",
                                           textAlign: "center",
                                         }}
                                       >
                                         {product.description}
                                       </div>
                                     </div>
                                   </div>
                                 ))}
                               </div>
                             ))}
                             <a
                               href="#"
                               style={{
                                 color: "#004aad",
                                 fontWeight: "600",
                                 fontSize: "14px",
                                 textDecoration: "none",
                                 display: "inline-flex",
                                 alignItems: "center",
                                 padding: "8px",
                               }}
                               onClick={() => setIsMobileMenuOpen(false)}
                             >
                               Explore all products
                               <img
                                 src={right}
                                 alt="arrow"
                                 style={{
                                   marginLeft: "4px",
                                   width: "16px",
                                   height: "16px",
                                   verticalAlign: "middle",
                                 }}
                               />
                             </a>
                           </div>
                         )}
                       </>
                     ) : (
                       <div
                         onClick={() => {
                           handleClick(item);
                           setIsMobileMenuOpen(false);
                         }}
                         style={{
                           fontSize: "16px",
                           cursor: "pointer",
                           fontWeight: "600",
                           color: "#004aad",
                           padding: "12px",
                           borderRadius: "8px",
                           transition: "background-color 0.3s",
                           textAlign: "center",
                         }}
                         onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                         onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                       >
                         {item}
                       </div>
                     )}
                   </div>
                 ))}
       
                 {/* Buttons */}
                 <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "12px",
                     width: "100%",
                     marginTop: "20px",
                   }}
                 >
                   <button
                     onClick={() => {
                       window.location.href = "http://app.mawalog.com/login";
                       setIsMobileMenuOpen(false);
                     }}
                     style={{
                       padding: "8px 16px",
                       borderRadius: "20px",
                       border: "1px solid #004aad",
                       backgroundColor: "#fff",
                       color: "#004aad",
                       fontWeight: "bold",
                       cursor: "pointer",
                       fontSize: "14px",
                       width: "100%",
                       transition: "background-color 0.3s",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                   >
                     Login
                   </button>
                   <button
                     onClick={() => {
                       window.open("https://app.mawalog.com/register", "_blank");
                       setIsMobileMenuOpen(false);
                     }}
                     style={{
                       padding: "8px 16px",
                       borderRadius: "20px",
                       border: "none",
                       backgroundColor: "#004aad",
                       color: "#fff",
                       fontWeight: "bold",
                       cursor: "pointer",
                       fontSize: "14px",
                       width: "100%",
                       transition: "background-color 0.3s",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                   >
                     Register
                   </button>
                 </div>
               </div>
             )}
       
             {/* Media Queries for Tablet Button Size */}
             <style>
               {`
                 @media (min-width: 769px) and (max-width: 1024px) {
                   .login-button, .register-button {
                     padding: 8px 16px !important;
                     font-size: 14px !important;
                   }
                 }
               `}
             </style>
           </>

      {/* Hero Section */}
<div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    padding: "clamp(20px, 5vw, 40px) clamp(3%, 5vw, 5%)",
    backgroundColor: "#ffffff",
    gap: "clamp(15px, 3vw, 20px)",
    maxWidth: "1400px",
    margin: "0 auto",
  }}
>
  {/* ──────────────────────── text block ──────────────────────── */}
  <div
    style={{
      flex: "1 1 clamp(300px, 50vw, 500px)",
      minWidth: "clamp(250px, 40vw, 300px)",
      marginBottom: "0",
    }}
  >
    {/* heading */}
    <div
      style={{
        fontSize: "clamp(20px, 3vw, 32px)",
        fontWeight: "bold",
        color: "#181835",
        marginLeft: "clamp(50px, 10vw, 100px)",
        marginBottom: "clamp(15px, 2vw, 20px)",
      }}
    >
      So how did <br />
      <span style={{ color: "#004BA8" }}>Mawalog</span> <br />
      come to be?
    </div>

    {/* paragraph */}
    <div
      style={{
        fontSize: "clamp(12px, 1.5vw, 14px)",
        color: "#616161",
        marginLeft: "clamp(50px, 10vw, 100px)",
        lineHeight: "1.6",
      }}
    >
      We evolved from collaboration to revolutionizing <br />
      supply-chain management, providing a unified platform <br />
      for efficient manufacturing, logistics, and warehousing.
    </div>
  </div>

  {/* ──────────────────────── image block ──────────────────────── */}
  <div
    style={{
      flex: "1 1 clamp(300px, 40vw, 400px)",
      display: "flex",
      justifyContent: "flex-start",
      marginRight: "clamp(20px, 5vw, 40px)",
    }}
    className="header-container"
  >
    <style>{`
      /* floating animation */
      @keyframes moveUpDown {
        0%   { transform: translateY(0); }
        50%  { transform: translateY(-10px); }
        100% { transform: translateY(0); }
      }

      .header-container img {
        animation: moveUpDown 2s ease-in-out infinite;
        width: 100%;
        max-width: clamp(200px, 50vw, 400px);
        height: auto;
      }

      /* ---------- desktop fine-tuning already present ---------- */
      @media (max-width: 1024px) {
        .header-container img { max-width: clamp(200px, 45vw, 350px); }
      }
      @media (max-width: 768px) {
        .header-container img { max-width: clamp(180px, 40vw, 280px); }
      }
      @media (max-width: 480px) {
        .header-container img { max-width: clamp(150px, 35vw, 200px); }
      }

      /* ---------- NEW: center the whole image block on ≤1024 px ---------- */
      @media (max-width: 1024px) {
        .header-container {
          justify-content: center !important;   /* center flex child */
          margin: 0 auto !important;            /* cancel side offset */
        }
      }
    `}</style>

    <img
      src={header}
      alt="Header illustration"
      style={{ width: "100%", maxWidth: "433px", height: "auto" }}
    />
  </div>
</div>



      {/* Who We Are Section */}
      <div
        style={{
          backgroundColor: "#F5F7FA",
          textAlign: "center",
          padding: "clamp(30px, 5vw, 50px) clamp(10px, 3vw, 20px)",
        }}
      >
        <style>{`
          @media (max-width: 1024px) {
            .who-we-are-card { max-width: clamp(280px, 45vw, 350px) !important; }
          }
          @media (max-width: 768px) {
            .who-we-are-card { max-width: 100% !important; min-width: clamp(250px, 80vw, 300px); }
          }
          @media (max-width: 480px) {
            .who-we-are-card { padding: clamp(20px, 5vw, 25px); }
          }
        `}</style>
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "white",
            padding: "clamp(6px, 1.5vw, 8px) clamp(12px, 2vw, 16px)",
            borderRadius: "20px",
            fontSize: "clamp(12px, 1.8vw, 14px)",
            fontWeight: "bold",
            color: "#004BA8",
          }}
        >
          <img
            src={flag}
            alt="Icon"
            style={{
              width: "clamp(14px, 2vw, 18px)",
              height: "clamp(14px, 2vw, 18px)",
              marginRight: "8px",
            }}
          />
          WHO WE ARE
        </div>
        <h2
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            fontSize: "clamp(20px, 3vw, 34px)",
            fontWeight: "bold",
            color: "#181835",
            marginTop: "clamp(15px, 2vw, 20px)",
          }}
        >
          We are Mawalogone, committed to <br />
          innovation and efficiency.
        </h2>
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "clamp(20px, 3vw, 30px)",
            padding: "clamp(30px, 5vw, 50px) clamp(10px, 3vw, 20px)",
            backgroundColor: "#F5F7FA",
          }}
        >
          <div
            className="who-we-are-card"
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
              padding: "clamp(20px, 4vw, 30px)",
              flex: "1 1 clamp(250px, 40vw, 300px)",
              maxWidth: "clamp(300px, 45vw, 400px)",
              minWidth: "clamp(250px, 40vw, 280px)",
              textAlign: "start",
            }}
          >
            <div
              style={{
                backgroundColor: "#E8F1FF",
                width: "clamp(40px, 5vw, 50px)",
                height: "clamp(40px, 5vw, 50px)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "clamp(8px, 1.5vw, 10px)",
              }}
            >
              <img
                src={mini}
                alt="Vision Icon"
                style={{ width: "clamp(16px, 2vw, 20px)" }}
              />
            </div>
            <div
              style={{
                fontSize: "clamp(16px, 2vw, 18px)",
                fontWeight: "bold",
                color: "#181835",
              }}
            >
              Our Vision is Inspiring Future
            </div>
            <p
              style={{
                fontSize: "clamp(12px, 1.8vw, 14px)",
                color: "#5A5A5A",
                marginTop: "clamp(8px, 1.5vw, 10px)",
              }}
            >
              Our vision is to transform supply chain management with a unified
              platform for manufacturing, logistics, and warehousing, ensuring
              efficiency and innovation.
            </p>
            <img
              src={bulb}
              alt="Vision"
              style={{
                width: "100%",
                borderRadius: "12px",
                marginTop: "clamp(15px, 2vw, 20px)",
              }}
            />
          </div>
          <div
            className="who-we-are-card"
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
              padding: "clamp(20px, 4vw, 30px)",
              flex: "1 1 clamp(250px, 40vw, 300px)",
              maxWidth: "clamp(300px, 45vw, 400px)",
              minWidth: "clamp(250px, 40vw, 280px)",
              textAlign: "start",
            }}
          >
            <div
              style={{
                backgroundColor: "#E8F1FF",
                width: "clamp(40px, 5vw, 50px)",
                height: "clamp(40px, 5vw, 50px)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "clamp(8px, 1.5vw, 10px)",
              }}
            >
              <img
                src={magic}
                alt="Goal Icon"
                style={{ width: "clamp(16px, 2vw, 20px)" }}
              />
            </div>
            <div
              style={{
                fontSize: "clamp(16px, 2vw, 18px)",
                fontWeight: "bold",
                color: "#181835",
              }}
            >
              Intentional act to reach a goal
            </div>
            <p
              style={{
                fontSize: "clamp(12px, 1.8vw, 14px)",
                color: "#5A5A5A",
                marginTop: "clamp(8px, 1.5vw, 10px)",
              }}
            >
              At Mawalog, we deliver value through innovation, reliability, and
              exceptional service, fostering lasting partnerships to drive
              client success.
            </p>
            <img
              src={rocket}
              alt="Goal"
              style={{
                width: "100%",
                borderRadius: "12px",
                marginTop: "clamp(15px, 2vw, 20px)",
              }}
            />
          </div>
        </div>
      </div>

      {/* Key Features Section */}
      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          textAlign: "center",
          padding: "clamp(30px, 5vw, 50px) clamp(10px, 3vw, 20px)",
          backgroundColor: "#fff",
          marginTop: "clamp(-50px, -5vw, -45px)",
        }}
      >
        <style>{`
          @media (max-width: 1024px) {
            .feature-card { max-width: clamp(250px, 45vw, 280px) !important; }
          }
          @media (max-width: 768px) {
            .feature-card { max-width: 100% !important; min-width: clamp(250px, 80vw, 300px); }
          }
          @media (max-width: 480px) {
            .feature-card { padding: clamp(15px, 4vw, 20px); }
          }
        `}</style>
        <h2
          style={{
            fontSize: "clamp(22px, 3vw, 38px)",
            fontWeight: "bold",
            color: "#181835",
          }}
        >
          Key features
        </h2>
        <p
          style={{
            fontSize: "clamp(14px, 1.8vw, 16px)",
            color: "#5A5A5A",
            marginBottom: "clamp(20px, 3vw, 40px)",
            maxWidth: "clamp(400px, 60vw, 600px)",
            marginInline: "auto",
          }}
        >
          What we seamlessly provide to our customers from our side
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "clamp(20px, 3vw, 40px)",
          }}
        >
          <div
            className="feature-card"
            style={{
              flex: "1 1 clamp(250px, 30vw, 280px)",
              maxWidth: "clamp(250px, 35vw, 300px)",
              textAlign: "start",
            }}
          >
            <img
              src={light}
              alt="Innovation"
              style={{
                width: "clamp(40px, 6vw, 60px)",
                marginBottom: "clamp(8px, 1.5vw, 10px)",
              }}
            />
            <div
              style={{
                fontSize: "clamp(16px, 2vw, 18px)",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Integrity & Innovation
            </div>
            <p
              style={{
                fontSize: "clamp(12px, 1.8vw, 14px)",
                color: "#5A5A5A",
              }}
            >
              We uphold the highest standards of trust and transparency while
              driving forward-thinking solutions to empower businesses.
            </p>
          </div>
          <div
            className="feature-card"
            style={{
              flex: "1 1 clamp(250px, 30vw, 280px)",
              maxWidth: "clamp(250px, 35vw, 300px)",
              textAlign: "start",
            }}
          >
            <img
              src={human}
              alt="People First"
              style={{
                width: "clamp(40px, 6vw, 60px)",
                marginBottom: "clamp(8px, 1.5vw, 10px)",
              }}
            />
            <div
              style={{
                fontSize: "clamp(16px, 2vw, 18px)",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              People First
            </div>
            <p
              style={{
                fontSize: "clamp(12px, 1.8vw, 14px)",
                color: "#5A5A5A",
              }}
            >
              We prioritize people with a user-centric approach, fostering
              trust, collaboration, and long-term success.
            </p>
          </div>
          <div
            className="feature-card"
            style={{
              flex: "1 1 clamp(250px, 30vw, 280px)",
              maxWidth: "clamp(250px, 35vw, 300px)",
              textAlign: "start",
            }}
          >
            <img
              src={ok}
              alt="Process Perfection"
              style={{
                width: "clamp(40px, 6vw, 60px)",
                marginBottom: "clamp(8px, 1.5vw, 10px)",
              }}
            />
            <div
              style={{
                fontSize: "clamp(16px, 2vw, 18px)",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Process Perfection
            </div>
            <p
              style={{
                fontSize: "clamp(12px, 1.8vw, 14px)",
                color: "#5A5A5A",
              }}
            >
              Streamlining operations with precision, efficiency, and innovation
              for seamless business growth.
            </p>
          </div>
        </div>
      </div>

      {/* Areas of Expertise Section */}
    <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    textAlign: "center",
    padding: "clamp(20px, 4vw, 30px)",
    backgroundColor: "#FCFAEF",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    className="_18frpri2"
    style={{
      position: "absolute",
      width: "clamp(200px, 40vw, 400px)",
      height: "clamp(200px, 40vw, 400px)",
      borderRadius: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 0,
      top: "50%",
      left: "50%",
      display: screenWidth >= 1024 ? "block" : "none",
      background:
        "radial-gradient(45.45% 50% at 50% 50%, rgb(238, 114, 114) 0, hsla(0, 0%, 100%, 0) 100%)",
      animation: "_18frpri1 12s linear infinite",
      opacity: 0.5,
    }}
  />
  <style>{`
    @keyframes _18frpri1 {
      0% { top: 10%; left: 10%; }
      25% { top: 20%; left: 80%; }
      50% { top: 50%; left: 50%; }
      75% { top: 80%; left: 20%; }
      100% { top: 10%; left: 10%; }
    }
    ._18frpri2 {
      position: absolute;
      border-radius: 50%;
      opacity: 0.5;
    }
    .expertise-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: clamp(15px, 3vw, 20px);
      row-gap: clamp(10px, 2vw, 15px);
      padding: clamp(8px, 2vw, 10px);
      justify-items: center;
    }
    @media (max-width: 1024px) {
      .expertise-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: clamp(12px, 2.5vw, 15px);
      }
      .expertise-grid > div[style*="gridColumn: 1 / span 3"] {
        grid-column: 1 / span 2;
        flex-direction: column;
        gap: clamp(15px, 3vw, 20px);
      }
      .expertise-grid > div[style*="gridColumn: 1 / span 3"] > div {
        flex-direction: column;
      }
    }
    @media (max-width: 768px) {
      .expertise-grid {
        grid-template-columns: 1fr;
        gap: clamp(10px, 2vw, 12px);
      }
      .expertise-grid > div[style*="gridColumn: 1 / span 3"] {
        grid-column: 1 / span 1;
      }
    }
    @media (max-width: 480px) {
      .expertise-grid > div {
        width: 100%;
        max-width: clamp(250px, 80vw, 300px);
        padding: clamp(20px, 5vw, 25px);
      }
    }
  `}</style>
  <div
    style={{
      maxWidth: "clamp(800px, 90vw, 1200px)",
      margin: "0 auto",
      padding: "clamp(20px, 4vw, 30px)",
      zIndex: 1,
      position: "relative",
    }}
  >
    <div
      style={{
        fontSize: "clamp(28px, 4vw, 38px)",
        fontWeight: "bold",
        color: "#181835",
        marginBottom: "clamp(30px, 5vw, 50px)",
      }}
    >
      Our Areas of Expertise
    </div>
    <div
      style={{
        fontSize: "clamp(14px, 2vw, 16px)",
        color: "#5A5A5A",
        maxWidth: "clamp(500px, 80vw, 700px)",
        margin: "clamp(8px, 1.5vw, 10px) auto clamp(20px, 3vw, 30px)",
      }}
    >
      We understand that managing manufacturing, logistics, and warehouse
      operations separately can be time-consuming and inefficient.
    </div>
   <div className="expertise-grid">
  {expertiseData.map((item, index) => {
    if (index === expertiseData.length - 2) {
      return (
        <div
          key={`pair-${index}`}
          style={{
            gridColumn: isMobile ? "1 / span 1" : "1 / span 3",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "clamp(20px, 3vw, 40px)",
            justifyContent: "center",
            alignItems: "stretch",
            margin: isMobile ? "0 auto" : "0", // Center the pair container on mobile
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "clamp(15px, 2vw, 20px)",
              alignItems: "center",
              justifyContent: "center",
              margin: isMobile ? "0 auto" : "0", // Extra safety for centering on mobile
            }}
          >
            {[item, expertiseData[index + 1]].filter(Boolean).map((innerItem, i) => (
              <div
                key={index + i}
                onMouseEnter={() => setHoveredIndex(index + i)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "clamp(20px, 4vw, 30px)",
          backgroundColor: "white",
          textAlign: "center",
          height: "clamp(120px, 40vw, 130px)",
          width: isMobile ? "100%" : "clamp(250px, 40vw, 300px)",
          maxWidth: isMobile ? 300 : "none",
          margin: isMobile ? "0 auto" : "0",
          boxSizing: "border-box",
          transition: "0.3s ease-in-out",
          borderRadius: "10px",
          boxShadow:
            hoveredIndex === index
              ? "0px 10px 20px #FFFAD3"
              : "0px 4px 10px rgba(255, 250, 211, 0.5)",
        }}
              >
                {hoveredIndex !== index + i ? (
                  <>
                    <div style={{ marginBottom: "clamp(8px, 1.5vw, 10px)" }}>
                      <img
                        src={innerItem.image}
                        alt={innerItem.title}
                        style={{
                          width: "clamp(35px, 5vw, 45px)",
                          height: "clamp(35px, 5vw, 45px)",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "clamp(14px, 2vw, 16px)",
                        fontWeight: "bold",
                        color: "#333",
                      }}
                    >
                      {innerItem.title}
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      maxWidth: "clamp(200px, 80vw, 250px)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "clamp(13px, 1.8vw, 14px)",
                        fontWeight: "bold",
                        color: "#181835",
                        marginBottom: "5px",
                      }}
                    >
                      {randomTexts[index + i]?.heading}
                    </div>
                    <div
                      style={{
                        fontSize: "clamp(11px, 1.5vw, 12px)",
                        color: "#888888",
                        fontWeight: "400",
                        lineHeight: "1.6",
                        textAlign: "center",
                      }}
                    >
                      {randomTexts[index + i]?.text}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (index === expertiseData.length - 1) return null;

    return (
      <div
        key={index}
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "clamp(20px, 4vw, 30px)",
          backgroundColor: "white",
          textAlign: "center",
          height: "clamp(120px, 40vw, 130px)",
          width: isMobile ? "100%" : "clamp(250px, 40vw, 300px)",
          maxWidth: isMobile ? 300 : "none",
          margin: isMobile ? "0 auto" : "0",
          boxSizing: "border-box",
          transition: "0.3s ease-in-out",
          borderRadius: "10px",
          boxShadow:
            hoveredIndex === index
              ? "0px 10px 20px #FFFAD3"
              : "0px 4px 10px rgba(255, 250, 211, 0.5)",
        }}
      >
        {hoveredIndex !== index ? (
          <>
            <div style={{ marginBottom: "clamp(8px, 1.5vw, 10px)" }}>
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: "clamp(35px, 5vw, 45px)",
                  height: "clamp(35px, 5vw, 45px)",
                  objectFit: "contain",
                }}
              />
            </div>
            <div
              style={{
                fontSize: "clamp(14px, 2vw, 16px)",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              {item.title}
            </div>
          </>
        ) : (
          <div
            style={{
              textAlign: "center",
              maxWidth: "clamp(200px, 80vw, 250px)",
            }}
          >
            <div
              style={{
                fontSize: "clamp(13px, 1.8vw, 14px)",
                fontWeight: "bold",
                color: "#181835",
                marginBottom: "5px",
              }}
            >
              {randomTexts[index]?.heading}
            </div>
            <div
              style={{
                fontSize: "clamp(11px, 1.5vw, 12px)",
                color: "#888888",
                fontWeight: "400",
                lineHeight: "1.6",
                textAlign: "center",
              }}
            >
              {randomTexts[index]?.text}
            </div>
          </div>
        )}
      </div>
    );
  })}
</div>
  </div>
</div>


      {/* What Sets Us Apart Section */}
      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "clamp(20px, 4vw, 40px)",
          padding: "clamp(30px, 5vw, 50px) clamp(10px, 3vw, 20px)",
        }}
      >
        <img
          src={women}
          alt="Woman with Laptop"
          style={{
            width: "100%",
            maxWidth: "clamp(300px, 50vw, 550px)",
            height: "auto",
            marginTop: "clamp(-50px, -5vw, -30px)",
            zIndex: 1,
          }}
        />
        <div
          style={{
            flex: "1 1 clamp(300px, 50vw, 500px)",
            minWidth: "clamp(250px, 40vw, 300px)",
            maxWidth: "clamp(400px, 60vw, 600px)",
          }}
        >
          <div
            style={{
              color: "#2653A5",
              fontSize: "clamp(12px, 1.8vw, 14px)",
              fontWeight: "bold",
              letterSpacing: "1px",
              textTransform: "uppercase",
            }}
          >
            What Sets Us Apart
          </div>
          <h2
            style={{
              fontSize: "clamp(24px, 3vw, 32px)",
              fontWeight: "bold",
              color: "#1E1E1E",
              marginTop: "clamp(8px, 1.5vw, 10px)",
            }}
          >
            Ready to simplify your supply
            <br />
            chain management?
          </h2>
          <p
            style={{
              fontSize: "clamp(14px, 1.8vw, 16px)",
              color: "#6B7280",
              lineHeight: "1.6",
              marginTop: "clamp(15px, 2vw, 20px)",
            }}
          >
            At Mawalog, we understand that managing manufacturing, logistics,
            and warehouse operations separately can be time-consuming and
            inefficient. That’s why we’ve developed a comprehensive platform
            that brings all these functions together, offering users a seamless
            and integrated experience.
          </p>
        </div>
      </div>

      {/* Compliance Section */}
       {/* <div
                     style={{
                       fontFamily: "Epilogue",
                       lineHeight: "1.4",
                       padding: "clamp(30px, 5vw, 60px)",
                       marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
                     }}
                   >
                     <div
                       style={{
                         maxWidth: "clamp(800px, 90vw, 1200px)",
                         margin: "0 auto",
                       }}
                     >
                       <div
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center",
                         }}
                       >
                         <div
                           style={{
                             color: "#181835",
                             fontSize: "clamp(18px, 2.5vw, 22px)",
                             fontWeight: "bold",
                             paddingLeft: screenWidth <= 1440 ? "clamp(50px, 10vw, 110px)" : "clamp(100px, 12vw, 170px)",
                             alignSelf: "flex-start",
                           }}
                         >
                           Compliance of our company
                         </div>
                         <div
                           style={{
                             display: "flex",
                             justifyContent: "center",
                             gap: "clamp(10px, 2vw, 15px)",
                             marginTop: "clamp(15px, 2vw, 20px)",
                             flexWrap: "wrap",
                           }}
                         >
                           {complianceData.slice(0, 3).map((item, index) => (
                             <div
                               key={index}
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 backgroundColor: "#F4F7FF",
                                 width: "clamp(200px, 30vw, 270px)",
                                 height: "clamp(35px, 5vw, 40px)",
                                 padding: "clamp(4px, 1vw, 5px)",
                                 borderRadius: "30px",
                                 justifyContent: "space-between",
                                 cursor: "pointer",
                                 transition: "background-color 0.3s, transform 0.3s ease",
                                 marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                               }}
                               onMouseEnter={(e) => {
                                 e.currentTarget.style.backgroundColor = "#EDF4FF";
                                 e.currentTarget.style.transform = "scale(1.03)";
                               }}
                               onMouseLeave={(e) => {
                                 e.currentTarget.style.backgroundColor = "#F4F7FF";
                                 e.currentTarget.style.transform = "scale(1)";
                               }}
                             >
                               <div style={{ display: "flex", alignItems: "center" }}>
                                 <div
                                   style={{
                                     borderRadius: "50%",
                                     padding: "clamp(8px, 1.5vw, 10px)",
                                     marginRight: "clamp(8px, 1.5vw, 12px)",
                                   }}
                                 >
                                   <img
                                     src={item.icon}
                                     alt={item.title}
                                     style={{
                                       width: "clamp(30px, 4vw, 40px)",
                                       height: "clamp(30px, 4vw, 40px)",
                                     }}
                                   />
                                 </div>
                                 <span
                                   style={{
                                     color: "#181835",
                                     fontSize: "clamp(10px, 1.5vw, 12px)",
                                     marginRight: "-10px",
                                   }}
                                 >
                                   {item.title}
                                 </span>
                               </div>
                               <img
                                 src={riarr}
                                 alt="Arrow"
                                 style={{
                                   width: "clamp(14px, 2vw, 18px)",
                                   height: "clamp(14px, 2vw, 18px)",
                                 }}
                               />
                             </div>
                           ))}
                         </div>
                       </div>
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           gap: "clamp(10px, 2vw, 15px)",
                           marginTop: "clamp(15px, 2vw, 20px)",
                           flexWrap: "wrap",
                           marginRight: screenWidth <= 1024 ? "clamp(5px, 2vw, 10px)" : "clamp(100px, 20vw, 290px)",
                         }}
                       >
                         {complianceData.slice(3, 5).map((item, index) => (
                           <div
                             key={index}
                             style={{
                               display: "flex",
                               alignItems: "center",
                               backgroundColor: "#F4F7FF",
                               width: "clamp(200px, 30vw, 270px)",
                               height: "clamp(35px, 5vw, 40px)",
                               padding: "clamp(4px, 1vw, 5px)",
                               borderRadius: "30px",
                               justifyContent: "space-between",
                               cursor: "pointer",
                               transition: "background-color 0.3s, transform 0.3s ease",
                               marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                             }}
                             onMouseEnter={(e) => {
                               e.currentTarget.style.backgroundColor = "#EDF4FF";
                               e.currentTarget.style.transform = "scale(1.03)";
                             }}
                             onMouseLeave={(e) => {
                               e.currentTarget.style.backgroundColor = "#F4F7FF";
                               e.currentTarget.style.transform = "scale(1)";
                             }}
                           >
                             <div style={{ display: "flex", alignItems: "center" }}>
                               <div
                                 style={{
                                   borderRadius: "50%",
                                   padding: "clamp(8px, 1.5vw, 10px)",
                                   marginRight: "clamp(8px, 1.5vw, 12px)",
                                 }}
                               >
                                 <img
                                   src={item.icon}
                                   alt={item.title}
                                   style={{
                                     width: "clamp(30px, 4vw, 40px)",
                                     height: "clamp(30px, 4vw, 40px)",
                                   }}
                                 />
                               </div>
                               <span
                                 style={{
                                   color: "#181835",
                                   fontSize: "clamp(10px, 1.5vw, 12px)",
                                   marginRight: "-10px",
                                 }}
                               >
                                 {item.title}
                               </span>
                             </div>
                             <img
                               src={riarr}
                               alt="Arrow"
                               style={{
                                 width: "clamp(14px, 2vw, 18px)",
                                 height: "clamp(14px, 2vw, 18px)",
                               }}
                             />
                           </div>
                         ))}
                       </div>
                     </div>
                   </div> */}
      
              {/* Newsletter Section */}
              <div
                     style={{
                       fontFamily: "Epilogue",
                       lineHeight: "1.4",
                       display: "flex",
                       alignItems: "center",
                       marginTop: "-20px",
                       justifyContent: "center",
                       backgroundColor: "#004BA8",
                       padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
                       color: "#fff",
                     }}
                     className="newsletter-section"
                   >
                     <div
                       style={{
                         marginRight: "clamp(20px, 3vw, 40px)",
                         marginBottom: "clamp(16px, 2vw, 20px)",
                       }}
                     >
                       <img
                         src={news}
                         alt="Newsletter"
                         style={{
                           width: "clamp(150px, 20vw, 200px)",
                           height: "clamp(120px, 15vw, 170px)",
                           animation: "floatImage 3s ease-in-out infinite",
                         }}
                       />
                     </div>
             
                     <style>
                       {`
                   @keyframes floatImage {
                     0% { transform: translateY(0); }
                     50% { transform: translateY(-10px); }
                     100% { transform: translateY(0); }
                   }
             
                   @media (max-width: 480px) {
                     .newsletter-section {
                       flex-direction: column;
                       text-align: center;
                       padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
                     }
                     .newsletter-section > div:first-child {
                       margin-right: 0;
                       margin-bottom: clamp(16px, 2vw, 20px);
                     }
                     .newsletter-section h2,
                     .newsletter-section p,
                     .newsletter-section > div > div,
                     .newsletter-section > div > div:last-child {
                       margin-left: 0;
                     }
                     .newsletter-section .newsletter-input {
                       min-width: clamp(200px, 80vw, 260px);
                     }
                     .newsletter-section button {
                     
                       display: block;
                     }
                   }
                 `}
                     </style>
             
                     <div className="newsletter-content">
          {/* Title and Paragraph */}
          <>
            <style>
              {`
      .newsletter-text {
        font-family: Epilogue;
        line-height: 1.4;
        font-size: 22px;
        margin-bottom: 10px;
        margin-left: 60px;
      }

      @media (max-width: 1024px) {
        .newsletter-text {
          font-size: 20px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-text {
          font-size: 18px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-text {
          font-size: 16px;
          margin-left: 30px;
        }
      }
    `}
            </style>

            <div className="newsletter-text">Subscribe to our Newsletter!</div>
          </>

          <>
            <style>
              {`
      .newsletter-description {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: start;
        margin-left: 60px;
        max-width: 100%;
        box-sizing: border-box;
      }

      @media (max-width: 1024px) {
        .newsletter-description {
          font-size: 13px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-description {
          font-size: 12.5px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-description {
          font-size: 9px; /* reduced more for small screens */
          text-align: center;
      
        }
      }
    `}
            </style>

            <div className="newsletter-description">
              Stay updated with our latest news, offers, and insights! Subscribe{" "}
              <br />
              for exclusive updates delivered straight to your inbox.
            </div>
          </>

          
        <>
  <style>
    {`
      .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 10px auto; /* center aligned */
        flex-wrap: nowrap;
      }

      .email-input {
        padding: 14px 16px 14px 48px;
        border-radius: 10px;
        border: 1px solid #9FCAFF;
        outline: none;
        background-color: #00377B;
        color: #fff;
        flex: 1;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
      }

      .email-icon {
        position: absolute;
        left: 16px;
        width: 20px;
        height: 20px;
      }

      /* Optional: Keep consistent appearance on all devices */
      @media (max-width: 480px) {
        .email-input {
          padding: 12px 12px 12px 44px;
          font-size: 14px;
        }
      }
    `}
  </style>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
    }}
  >
    <div className="input-wrapper">
      <img src={mail} alt="Email Icon" className="email-icon" />
      <input
        type="email"
        value={email}
        placeholder="sample@gmail.com"
        className="email-input"
        onChange={handleChange}
      />
    </div>
  </div>
</>


         
          <>
            <style>{`
        .captcha-container {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          border-radius: 20px !important;    
          gap: 8px !important;
          flex-wrap: wrap !important;
        }
      .captcha-box {
  width: 60px !important;
  height: 40px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important; /* Add this to clip canvas overflow */
}

#captchaCanvas {
  border-radius: 20px !important;
}
        .captcha-input {
          padding:10px 1px!important;
          border-radius:8px!important;
          border:1px solid #ccc!important;
          outline:none!important;
          min-width:120px!important;
          background:#00377B!important;
          color:#fff!important;
        }
        .subscribe-button {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#0A3A72!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
        @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
        @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
      `}</style>

            <div className="captcha-container">
              <div className="captcha-box">
                <canvas
                  ref={canvasRef}
                  id="captchaCanvas"
                  width={60}
                  height={40}
                />
              </div>

              <button
                onClick={handleReload}
                style={{
                  background: "#2563EB",
                  color: "#fff",
                  border: "none",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Your reload SVG icon here */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>

              <input
                type="text"
                placeholder="Enter captcha"
                value={userCaptcha}
                onChange={(e) => setUserCaptcha(e.target.value)}
                className="captcha-input"
              />

              <button className="subscribe-button" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
          </>

          {/* Note */}
          <div
            style={{
              fontSize: "12px",
              marginTop: "10px",
              color: "#fff",
              marginLeft:
                window.innerWidth <= 480
                  ? "20px"
                  : window.innerWidth <= 768
                  ? "40px"
                  : window.innerWidth <= 1024
                  ? "50px"
                  : "60px",
            }}
          >
            *Unsubscribe anytime. We don’t send any spam
          </div>
        </div>
                   </div>
      
              {/* Footer */}
     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={phone}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>
      
              <div
                style={{
                  fontFamily: "Epilogue",
                  lineHeight: "1.4",
                  textAlign: "center",
                  padding: isMobile ? "15px 0" : "20px 0",
                  borderTop: "1px solid #ddd",
                  fontSize: isMobile ? "12px" : "14px",
                  color: "#333",
                }}
              >
                Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
            </div>
    </div>
  );
};

export default About;